const lastCalls: {func: object; lastCall: number}[] = [];

export const throttle = (func: any, timeoutMs: number = 1000) => {
  if (!func) {
    return;
  }

  const previousCallEntryIndex = lastCalls.findIndex((v) => v.func === func);
  const previousCall = previousCallEntryIndex > -1 ? lastCalls[previousCallEntryIndex].lastCall : 0;
  const now = Date.now();

  if (!previousCall || now - previousCall > timeoutMs) {
    if (previousCall) {
      lastCalls[previousCallEntryIndex].lastCall = now;
    } else {
      lastCalls.push({func, lastCall: now});
    }
    func();
  }
};
